import Axios from 'axios';
export * from 'axios';
import router from '../../router';
import store from '@/store';

const API_URL =
  process.env.NODE_ENV !== 'development' ? `${window.location.origin}/api/v1/` : 'http://localhost:5000/api/v1/';

const axios = Axios.create({
  withCredentials: true,
  baseURL: API_URL
});

axios.defaults.timeout = 180000;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  ({ response, message }) => {
    if ((!response || response?.status === 401 || response?.status === 500) && store.getters['user/isAuth']) {
      router.push({ name: 'Logout' });
    }
    throw new Error(`${response?.data?.message || message || 'Unhandled server error!'}`);
  }
);

export default axios;
